import { AppState } from '@/store';

export const selectIsPosthogInitialized = (state: AppState) => state.posthog.initialized;
